export default __webpack_public_path__ + "static/media/pensionsdagen2025.dbd8d9bd.jpg";